export const sahel = {
  landmarks: [
    "طريق العلمين",
    "سيدي عبد الرحمن",
    "مارينا",
    "الضبعة",
    "رأس الحكمة",
    "العلمين الجديدة",
    "طريق الساحل الدولي"
  ],
  title: "ونش انقاذ الساحل الشمالي | طريق العلمين وسيدي عبد الرحمن | خصم 50%",
  metaDescription: "ونش انقاذ الساحل الشمالي والعلمين وطريق الضبعة. خدمة طوارئ الطرق السريعة ونقل السيارات لمسافات طويلة بأحدث الأوناش المسطحة المجهزة للرحلات. خصم 50%.",
  intro: `رحلتك إلى الساحل الشمالي يجب أن تكون مليئة بالاسترخاء والمتعة، ولكن إذا واجهت عطلاً مفاجئاً على طريق العلمين أو بالقرب من مارينا وسيدي عبد الرحمن، فقد يتحول الأمر إلى كابوس. المسافات الطويلة بين القرى السياحية والمدن تتطلب استجابة من خدمة إنقاذ متخصصة ومجهزة للتعامل مع الطرق السريعة.
  نحن نوفر خدمة ونش انقاذ الساحل الشمالي بأوناش متمركزة طوال فترة الصيف وعلى مدار العام بالقرب من النقاط الحيوية. نمتلك أوناشاً هيدروليكية حديثة وموثوقة لضمان نقل سيارتك بأمان تام لمسافات طويلة، سواء أردت إيصالها لمركز صيانة قريب في الإسكندرية أو نقلها مباشرة إلى القاهرة.`,
  highlights: [
    "تغطية شاملة لطريق الساحل من العلمين الجديدة وحتى رأس الحكمة",
    "أوناش مسطحة (Flatbed) توفر أقصى درجات الحماية للسيارات الفارهة",
    "خدمة نقل السيارات من الساحل الشمالي إلى القاهرة بأمان وسرعة",
    "استجابة طوارئ سريعة للحوادث والأعطال الليلية على طريق الضبعة"
  ],
  safetyTips: [
    "إذا تعطلت على طريق الساحل الدولي، اركن السيارة أقصى اليمين بعيداً عن مسار السيارات المسرعة وشغّل الأضواء التحذيرية.",
    "استخدم المثلث العاكس وضعه على مسافة بعيدة خلف السيارة لتنبيه السائقين، خاصة في المناطق غير المضاءة جيداً.",
    "أرسل موقعك (Location) الدقيق عبر الواتساب لتسهيل وصول الونش إليك في أقصر وقت ممكن."
  ],
  faqs: [
    {
      q: "هل توفرون خدمة نقل السيارات المعطلة من الساحل الشمالي إلى القاهرة؟",
      a: "نعم، لدينا أوناش مجهزة للرحلات الطويلة، توفر نقل آمن لسيارتك من أي قرية في الساحل الشمالي حتى منزلك أو توكيل الصيانة في القاهرة."
    },
    {
      q: "سيارتي رياضية وغالية الثمن، هل هناك خطر عليها أثناء النقل مسافة طويلة؟",
      a: "نحن نستخدم أوناش السطحة التي ترفع السيارة بالكامل وتثبتها بواسطة أحزمة خاصة للإطارات دون المساس بالهيكل، مما يضمن وصولها بدون أي خدش."
    },
    {
      q: "كم يستغرق الونش للوصول إليّ في سيدي عبد الرحمن؟",
      a: "بسبب التمركز الاستراتيجي لسياراتنا على طريق الساحل، يمكننا الوصول إلى سيدي عبد الرحمن أو مارينا خلال 15 إلى 30 دقيقة."
    },
    {
      q: "هل تقدمون خدمة المساعدة لفتح السيارات إذا نسيت المفتاح بداخلها في مارينا؟",
      a: "نعم، نوفر فنيين مزودين بمعدات خاصة لفتح السيارات المقفلة باحترافية وسرعة دون كسر الزجاج."
    }
  ],
  seoText: `
    <h2>خدمة ونش إنقاذ متخصصة لرواد الساحل الشمالي والعلمين</h2>
    <p>خدمات الإنقاذ في الساحل الشمالي تتطلب كفاءة وسرعة، خصوصاً في أوقات الصيف والذروة حيث تزداد الكثافة المرورية على طريق العلمين وطريق الضبعة. نحن في ونش انقاذ الساحل الشمالي ندرك أن وقتك في العطلة ثمين، ولذلك نهدف إلى تقديم أسرع وأكثر خدمات الإنقاذ أماناً لحل مشكلتك في أسرع وقت.</p>

    <h3>معدات مصممة للطرق السريعة والسفر الطويل</h3>
    <p>نقل سيارة معطلة من الساحل إلى القاهرة يختلف عن سحبها داخل المدينة. يحتاج الأمر إلى أوناش تتحمل المسافات الطويلة ومزودة بأنظمة تثبيت قوية تمنع اهتزاز السيارة أثناء السير بسرعات على الطريق الصحراوي. أسطولنا مجهز تماماً لهذه المهمة، مما يوفر لك الطمأنينة الكاملة.</p>

    <h3>تغطية تمتد للإسكندرية</h3>
    <p>بفضل شبكتنا الواسعة، يمكننا تقديم الدعم ونقل سيارتك إلى الإسكندرية إذا لزم الأمر، حيث يتعاون فريقنا مع <a href="/areas/اسكندرية">ونش انقاذ اسكندرية</a> لضمان تقديم أفضل مساعدة، سواء كنت متجهاً شرقاً أو غرباً. يمكنك السفر باطمئنان وأنت تعلم أن هناك فريق إنقاذ محترف يغطي مسارك.</p>
    <p>احفظ رقمنا قبل بدء رحلتك للساحل الشمالي لتكن دائماً في أمان.</p>
  `
};
